// services/tasks.js
import axiosInstance from './axiosInstance';

const TASKS_API_URL = '/tasks';

const tasksService = {
  async get(idempresa, posto = '') {
    try {
      const postoParam = posto ? `&posto=${posto}` : '';
      const response = await axiosInstance.get(`${TASKS_API_URL}/get.php?idempresa=${idempresa}${postoParam}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter tarefas:', error);
      return [];
    }
  },

  async set(taskData) {
    try {
      const response = await axiosInstance.post(`${TASKS_API_URL}/set.php`, taskData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar tarefa:', error);
      throw error;
    }
  }
};

export default tasksService;
